import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Form } from 'antd'

import Input from '../../common/Input'
import css from './ManualForm.css'

const inputs = [
  {
    label: 'Title',
    name: 'title',
  },
  {
    label: 'First Name',
    name: 'first_name',
  },
  {
    label: 'Last Name',
    name: 'last_name',
  },
  {
    label: 'Preferred Name',
    name: 'preferred_name',
  },
  {
    label: 'Email',
    name: 'email',
  },
]
export default class DoctorForm extends Component {
  static propTypes = {
    addOrEdit: PropTypes.func.isRequired,
    hideForm: PropTypes.func.isRequired,
    doctor: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      preferred_name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
  }

  static defaultProps = {
    doctor: null,
  }

  state = {
    first_name: '',
    last_name: '',
    preferred_name: '',
    email: '',
    title: '',
    isLoading: false,
  }

  componentWillMount() {
    const { doctor } = this.props
    if (doctor) {
      const { title, first_name, last_name, preferred_name, email } = doctor
      this.setState({
        title, first_name, last_name, preferred_name, email,
      })
    }
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.setState({
      isLoading: true,
    })
    const doctorId = this.props.doctor ? this.props.doctor.id : undefined
    const { title, first_name, last_name, preferred_name, email } = this.state
    this.props.addOrEdit({
      title, first_name, last_name, preferred_name, email,
    }, doctorId)
      .then(() => {
        this.props.hideForm()
      })
  }

  render() {
    return (
      <Form
        layout="horizontal"
        onSubmit={this.handleSubmit}
        className={css.form}
      >
        <div className={css.header}>
          <h3>New Doctor:</h3>
          <Button
            icon="close"
            onClick={this.props.hideForm}
            shape="circle"
          />
        </div>
        {inputs.map(input => (
          <Input
            key={input.name}
            label={input.label}
            value={this.state[input.name]}
            name={input.name}
            onChange={this.onInputChange}
          />
        ))}
        <Form.Item className={css.button}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!this.state.title || !this.state.first_name || !this.state.last_name || !this.state.preferred_name || !this.state.email}
            loading={this.state.isLoading}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/DoctorForm.js